module.exports = __webpack_public_path__ + "img/PD2017490248124203008.5702d617.png";